/* eslint-disable import/no-unresolved */
import ReduxProvider from './redux';
import ThemesProvider from './theme';
import RouterProvider from './routes';
import ReactQueryProvider from './react-query';
import BarcodeReaderProvider from './barcode-reader';
// import BarcodeReader from '@/components/BarcodeReader';
import ModalProvider from './modals';
import { ProvidersProps } from './providers.types';

const AppProvider: React.FC<ProvidersProps> = ({ children }) => (
  <ReduxProvider>
    <ReactQueryProvider>
      <ThemesProvider>
        <RouterProvider>
          <ModalProvider />
          <BarcodeReaderProvider>{children}</BarcodeReaderProvider>
        </RouterProvider>
      </ThemesProvider>
    </ReactQueryProvider>
  </ReduxProvider>
);

export default AppProvider;
